import React, { FormEvent, JSX, useEffect, useState } from 'react';
import { Button } from '@/components';
import { updateMask } from '@/helpers/masks/mobilePhone';

interface StateProps {
  email?: string;
  phone?: string;
  sendCodeEmail: boolean;
}

interface DispatchProps {
  isUserEmail: (e: FormEvent) => void;
  onChangePersonData: () => void;
}

type Props = StateProps & DispatchProps;

export const ChangePasswordCheckEmailContent: React.FC<Props> = ({
  email,
  phone,
  sendCodeEmail,
  isUserEmail,
  onChangePersonData,
}): JSX.Element => {
  const [secondsLeft, setSecondsLeft] = useState(10);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);

  useEffect(() => {
    if (secondsLeft > 0) {
      setTimeout(() => {
        setSecondsLeft(prev => prev - 1);
      }, 1000);
    } else {
      setIsButtonEnabled(true);
    }
  }, [secondsLeft]);

  return (
    <div className="mt-5 w-full">
      <div>
        <div className="self-start text-heading text-4xl font-dmsans font-bold mb-[15px]">
          Seu {sendCodeEmail ? 'e-mail' : 'whatsapp'} está correto?
        </div>

        <p className="text-heading text-lg font-dmsans font-normal mb-2">
          {`Verifique se o ${email ? 'e-mail' : 'numero de whatsapp'} abaixo está correto para continuar:`}
        </p>

        <p className="mb-[50px] text-heading text-2xl font-dmsans font-semibold w-4/5 break-words">
          {sendCodeEmail ? email : updateMask(phone || '')}
        </p>

        <div className="grid grid-cols-2 gap-4">
          <Button
            title={isButtonEnabled ? 'Sim, está correto' : `Aguarde (${secondsLeft}s)`}
            buttonStyle="primary"
            size="xlg"
            className="auto-cols-auto"
            onClick={isUserEmail}
            disabled={!isButtonEnabled}
          />
          <Button
            type="button"
            title={`Corrigir ${sendCodeEmail ? 'e-mail' : 'whatsapp'}`}
            buttonStyle="outlined"
            size="xlg"
            className="auto-cols-auto"
            onClick={onChangePersonData}
          />
        </div>
      </div>
    </div>
  );
};
